"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _constants = require("./constants");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.advanced-settings-header-class {\n  padding-bottom: 2rem; }\n  .advanced-settings-header-class .header-class {\n    margin-top: 2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #a8a8a8; }\n    .advanced-settings-header-class .header-class .margin-top-32 {\n      margin-top: 2rem; }\n    .advanced-settings-header-class .header-class .margin-top-8 {\n      margin-top: 0.5rem; }\n  .advanced-settings-header-class .ITSM-pill-container {\n    display: inline-block;\n    padding: 0.3125rem 0; }\n";
  var fileName = "compone_AdvancedSettings";
  var element = document.querySelector("style[data-sass-component='compone_AdvancedSettings']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

function ITSM(_ref) {
  var ITSMResponse = _ref.ITSMResponse;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFilterCriteriaOpen = _useState2[0],
      setIsFilterCriteriaOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      filterCriteriaJSON = _useState4[0],
      setFilterCriteriaJSON = _useState4[1];

  var _useState5 = (0, _react.useState)(-1),
      _useState6 = _slicedToArray(_useState5, 2),
      rowToBeView = _useState6[0],
      setRowToBeView = _useState6[1];

  (0, _react.useEffect)(function () {
    if (rowToBeView >= 0) {
      var data = ITSMResponse === null || ITSMResponse === void 0 ? void 0 : ITSMResponse.itsmFilterCriteria[rowToBeView];
      setFilterCriteriaJSON(JSON.stringify(data === null || data === void 0 ? void 0 : data.filter, null, 2));
      setIsFilterCriteriaOpen(true);
    }
  }, [rowToBeView]);
  var columns = [{
    field: 'key',
    headerName: 'Ticket Types Categories',
    width: '100px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell ".concat(_constants.classes.pillContainer)
      }, /*#__PURE__*/_react.default.createElement(_pill.default, {
        readOnly: true,
        label: _constants.ticketTypes[row === null || row === void 0 ? void 0 : row.supportedTicketType],
        key: row === null || row === void 0 ? void 0 : row.supportedTicketType
      }));
    }
  }, {
    headerName: 'Filter',
    width: '100px',
    renderColumn: function renderColumn(row, value, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell-autocomplete"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        size: "medium",
        variant: 'secondary',
        onClick: function onClick() {
          return setRowToBeView(index);
        }
      }, 'View Filter')));
    }
  }];

  var closeModal = function closeModal() {
    setIsFilterCriteriaOpen(false);
    setRowToBeView(-1);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "heading5"
  }, 'ITSM ', (ITSMResponse === null || ITSMResponse === void 0 ? void 0 : ITSMResponse.isInherited) && '(Inherited)  ')), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", 'Enable ITSM integration for Checkout and Approval Requests', " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, ITSMResponse !== null && ITSMResponse !== void 0 && ITSMResponse.isITSMEnabled ? 'Enabled' : 'Disabled'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, 'Selected ITSM Connection'), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, _constants.connectionTypeName[ITSMResponse === null || ITSMResponse === void 0 ? void 0 : ITSMResponse.connectionType] || 'None'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, 'Type'), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, (ITSMResponse === null || ITSMResponse === void 0 ? void 0 : ITSMResponse.settingsType) || 'None'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, !(0, _lodash.isEmpty)(ITSMResponse === null || ITSMResponse === void 0 ? void 0 : ITSMResponse.itsmFilterCriteria) ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '20%'
    }
  }, /*#__PURE__*/_react.default.createElement(_table.default, {
    resizableColumns: true,
    columns: columns || [],
    rows: (ITSMResponse === null || ITSMResponse === void 0 ? void 0 : ITSMResponse.itsmFilterCriteria) || []
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, 'Ticket Types Categories'), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, 'No ticket-type categories are present')))), isFilterCriteriaOpen && /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 500,
    title: "Filter Criteria",
    onCancel: closeModal
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    label: 'Filter Criteria JSON',
    value: filterCriteriaJSON,
    readOnly: true
  }))));
}

ITSM.propTypes = {
  ITSMResponse: _propTypes.default.object
};
var _default = ITSM;
exports.default = _default;